import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Loading from "../Loading"

const LoadingOverlay = ({show}) => {
    return show ? (
        <div className='loading-overlay'>
            <Loading
                width={80}
                fill={'var(--secondary-color)'}
                duration={".4s"}
            />
        </div>
    ) : null
}

LoadingOverlay.propTypes = {
    show: PropTypes.bool,
}

LoadingOverlay.defaultProps = {
    show: false,
}

export default LoadingOverlay



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/LoadingOverlay/index.js